import comp from "./StudentTemplates";
export default comp;
